import axios from 'axios'
import { Platform } from 'react-native'
import { useSessionStore } from '../lib/Store/sessionStore.component'
import { navigation } from '../lib/Navigation/Navigation.component'

// Configuration de l'API URL selon l'environnement
export const getApiUrl = () => {
  // En développement local WEB seulement, utiliser le proxy pour éviter CORS
  if (process.env.NODE_ENV === 'development' && Platform.OS === 'web') {
    return 'http://localhost:3000/api'
  }

  // Détection dynamique par hostname
  if (typeof window !== 'undefined' && Platform.OS === 'web')  {
    const host = window.location.hostname
    if (host.includes('qa')) {
      return 'https://360.qa.jvs-mairistem.dev/api'
    }
     if (host.includes('pp')) {
      return 'https://360.pp.jvs-mairistem.dev/api'
    }
    if (host.includes('dev')) {
      return 'https://360.jvs-mairistem.dev/api'
    }
    if (host.includes('jvsonline')) {
      return 'https://360.jvsonline.fr/api'
    }
  }

  // En production ou sur mobile, utiliser l'URL directe
  return process.env.REACT_APP_API_URL || 'https://360.jvs-mairistem.dev/api'
}

const API_URL = getApiUrl()


// Compteur pour gérer les appels multiples
export let activeRequests = 0

export const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: false
})

// Ajoute le token et active le loader à chaque requête
axiosInstance.interceptors.request.use(config => {
  // Récupérer les données depuis le store Zustand
  const { session } = useSessionStore.getState();
  const { access_token } = session || {}

  // Ajouter le token d'authentification
  if (access_token) {
    config.headers.Authorization = `Bearer ${access_token}`

    // Ajouter X-Tenant et X-Component depuis la session
    if (session?.base?.tenant) {
      config.headers['X-Tenant'] = session?.base.tenant
    }
    
    if (session?.base?.component) {
      config.headers['X-Component'] = session?.base.component
    }
  }
  
  // Activer le loader (sauf pour les requêtes silencieuses)
  if (!(config as any).silent) {
    activeRequests++
    useSessionStore.getState().setLoading(true, 'Chargement...')
  }
  
  return config
})

// Désactive le loader et gère le refresh automatique
axiosInstance.interceptors.response.use(
  response => {
    // Désactiver le loader (sauf pour les requêtes silencieuses)
    if (!(response.config as any).silent) {
      activeRequests--
      if (activeRequests === 0) {
        useSessionStore.getState().setLoading(false)
      }
    }
    return response
  },
  async error => {
    // Désactiver le loader même en cas d'erreur (sauf silent)
    if (!(error.config as any)?.silent) {
      activeRequests--
      if (activeRequests === 0) {
        useSessionStore.getState().setLoading(false)
      }
    }
    
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.error('❌ Erreur réseau - Vérifiez votre connexion')
    }
    
    if (error.response?.status === 401) {
      navigation.navigate('./')
    }
    return Promise.reject(error)
  }
)

// Récupérer les headers d'authentification pour les requêtes externes (RNBlobUtil, etc.)
export const getAuthHeaders = (): Record<string, string> => {
  const { session } = useSessionStore.getState();
  const headers: Record<string, string> = {};
  
  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`;
  }
  
  if (session?.base?.tenant) {
    headers['X-Tenant'] = String(session.base.tenant);
  }
  
  if (session?.base?.component) {
    headers['X-Component'] = String(session.base.component);
  }
  
  return headers;
}
